import { parse } from 'query-string';

export default function shouldPersistStore(): boolean {
  const { disableReduxPersist } = parse(global.location.search);
  return !disableReduxPersist;
}
